// extracted by mini-css-extract-plugin
export default {"alert-name":"search-alert_alert-name__rtjdL","selected-alert":"search-alert_selected-alert__YVMvd"};